import {environment} from "../environment/environment";


export function isAuthenticated() {

    return getToken() !== null;
}


export function storeUserData(accessToken) {
    localStorage.setItem(environment.LOCAL_STORAGE_TOKEN, accessToken);
}

export function storeCurrentLang(lang){
    localStorage.setItem(environment.LOCAL_STORAGE_LANGUAGE,lang);
    location.reload();
}

export function getCurrentLang(){
    return localStorage.getItem(environment.LOCAL_STORAGE_LANGUAGE);
}


export function getToken() {
    return localStorage.getItem(environment.LOCAL_STORAGE_TOKEN);
}

